
<template>
  <div class="body">
    <div class="boxtitle">
      <div class="btitle">
        <span>技能提升培训</span>
      </div>
      <div class="bbtn">
        <img src="../../../assets/img/reading/more.png"
             alt="">
        <span>更多</span>
      </div>
    </div>
    <div class="box">
      <div class="item"
           v-for="(item,index) in 3"
           :key="index">
        <img class="bimg"
             src="https://cgp-resource.oss-cn-beijing.aliyuncs.com/Images/Reading/reader.jpg"
             alt="" />
        <span class="btitle">以全科医生的职业发展为导向，打造最优质的全科医学教育数字平台</span>
        <div class="bbq">
          <span>高血压</span>
          <span>高血压</span>
          <span>高血压</span>
        </div>
        <div class="bmore">
          <div class="bmleft">
            <span>免费</span>
          </div>
          <div class="bmright">
            <img src="../../../assets/img/icon/ren.png"
                 alt="">
            <span>2253人</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
    }
  }
}
</script>
<style lang="scss" scoped>
.body {
    width: 1200px;
    margin: 0 auto;
    .boxtitle {
        width: 100%;
        border-bottom: 1px solid #ddd;
        margin: 40px 0 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .btitle {
            display: inline-block;
            font-size: 26px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            line-height: 26px;
            padding: 15px 0;
            border-bottom: 1px solid #000000;
        }
        .bbtn {
            display: flex;
            align-items: center;
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #404040;
            line-height: 28px;
            img {
                margin-right: 10px;
            }
        }
    }
    .box {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        margin-bottom: 20px;
        .item {
            display: flex;
            flex-direction: column;
            width: 383px;
            height: 355px;
            background: #ffffff;
            box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.04);
            border-radius: 0px 0px 5px 5px;
            overflow: hidden;
            .bimg {
                width: 383px;
                height: 215px;
            }
            .btitle {
                font-size: 16px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #000000;
                line-height: 20px;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                margin: 16px;
                height: 40px;
            }
            .bbq {
                font-size: 12px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #979fa6;
                line-height: 14px;
                margin-left: 16px;
                span {
                    padding: 2px 4px;
                    border: 1px solid #979fa6;
                    border-radius: 4px;
                    margin-right: 5px;
                }
            }
            .bmore {
                font-size: 14px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                line-height: 34px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin: 10px 16px;
                .bmleft {
                    color: #f01414;
                }
                .bmright {
                    color: #979fa6;
                    img {
                        margin-right: 3px;
                    }
                }
            }
        }
    }
}
</style>